// import React from 'react';
// import styles from './Offer.module.css';

// const Offer = () => {
//   return (

//     <section className={styles.quoteForm}>
//       <div className={styles.formContent}>
//         <h2 className={styles.formTitle}>קבל הצעת מחיר למייל</h2>
//         <form className={styles.formWrapper}>

//           <div className={styles.formFields}>

//             <div className={styles.inputGroup}>
//               <input
//                 type="text"
//                 id="fullName"
//                 className={styles.inputField}
//                 placeholder="שם מלא"
//               />
//             </div>

//             <div className={styles.inputGroup}>
//               <input
//                 type="tel"
//                 id="phone"
//                 className={styles.inputField}
//                 placeholder="טלפון"
//               />
//             </div>

//             <div className={styles.inputGroup}>
//               <input
//                 type="email"
//                 id="email"
//                 className={styles.inputField}
//                 placeholder="אימייל"
//               />
//             </div>

//           </div>

//           <button type="submit" className={styles.submitButton}>
//             שלח לי הצעת מחיר
//           </button>
          
//         </form>
//       </div>
//     </section>
//   );
// };

// export default Offer;

import React, { useState } from 'react';
import styles from './Offer.module.css';
import { useCart } from '../CartContext/CartContext';

const Offer = () => {
  const { cartItems } = useCart();
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    setSuccessMessage('');
    setIsLoading(true);

    // איסוף נתוני הטופס
    const formData = new FormData(e.target);
    const fullName = formData.get('fullName');
    const phone = formData.get('phone');
    const email = formData.get('email');

    // ולידציה בסיסית
    if (!fullName || !phone || !email) {
      setErrorMessage('אנא מלא את כל השדות');
      setIsLoading(false);
      return;
    }

    if (cartItems.length === 0) {
      setErrorMessage('העגלה ריקה - אנא הוסף מוצרים לפני שליחת הצעת מחיר');
      setIsLoading(false);
      return;
    }

    try {
      // הכנת הנתונים לשליחה
      const dataToSend = {
        customerInfo: {
          fullName,
          phone,
          email
        },
        cartItems: cartItems.map(item => ({
          name: item.name,
          image: item.image,
          price: item.price,
          quantity: item.quantity
        })),
        timestamp: new Date().toISOString()
      };

      // שליחת הבקשה לשרת
      const response = await fetch('https://web-production-53ef9.up.railway.app/send-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(dataToSend),
      });

      if (response.ok) {
        setSuccessMessage('✅ נשלח! שלחנו לך הצעה למייל');
        e.target.reset(); // איפוס הטופס
      } else {
        // טיפול בקודי שגיאה שונים
        switch (response.status) {
          case 400:
            setErrorMessage('❗ יש בעיה בפרטים, בדוק את האימייל או הפריטים ונסה שוב');
            break;
          case 401:
            setErrorMessage('🚫 אין הרשאה לביצוע הפעולה');
            break;
          case 429:
            setErrorMessage('⏳ שלחת יותר מדי בקשות, נסה שוב מאוחר יותר');
            break;
          case 500:
          case 502:
            setErrorMessage('⚠️ שגיאה זמנית בשרת, נסה שוב מאוחר יותר');
            break;
          default:
            setErrorMessage('❗ יש בעיה בפרטים, בדוק את האימייל או הפריטים ונסה שוב');
        }
      }
    } catch (error) {
      console.error('Error sending quotation:', error);
      setErrorMessage('⚠️ שגיאה זמנית בשרת, נסה שוב מאוחר יותר');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className={styles.quoteForm}>
      <div className={styles.formContent}>
        <h2 className={styles.formTitle}>קבל הצעת מחיר למייל</h2>
        <form className={styles.formWrapper} onSubmit={handleSubmit}>
          <div className={styles.formFields}>
            <div className={styles.inputGroup}>
              <input
                type="text"
                id="fullName"
                name="fullName"
                className={styles.inputField}
                placeholder="שם מלא"
                required
              />
            </div>
            <div className={styles.inputGroup}>
              <input
                type="tel"
                id="phone"
                name="phone"
                className={styles.inputField}
                placeholder="טלפון"
                required
              />
            </div>
            <div className={styles.inputGroup}>
              <input
                type="email"
                id="email"
                name="email"
                className={styles.inputField}
                placeholder="אימייל"
                required
              />
            </div>
          </div>
          <p className={styles.privacyText}>
            הפרטים ישמשו אך ורק לצורך שליחת הצעת מחיר חד-פעמית,<br/>
            בהתאם למדיניות הפרטיות שלנו.
          </p>
          <button type="submit" className={styles.submitButton} disabled={isLoading}>
            {isLoading ? 'שולח...' : 'שלח לי הצעת מחיר'}
          </button>
          {errorMessage && (
            <p className={styles.errorMessage}>{errorMessage}</p>
          )}
          {successMessage && (
            <p className={styles.successMessage}>{successMessage}</p>
          )}
        </form>
      </div>
    </section>
  );
};

export default Offer;